const API = {
  //socialMe: 'http://25.58.121.181:3000/v1',
  socialMe: 'https://v2.api.sigam.socialme.com.br/v1',
  //dev: 'https://dev.api.sigam.socialme.com.br/v1',
  // socialMe: 'http://25.17.12.216:3001/v1',
  // socialMe: 'http://25.108.94.125:3000/v1',
  // socialMe: 'https://socialme-pg-dev.herokuapp.com/v2',
  // socialMe: 'https://development-socialme-earth-api.herokuapp.com/v1',
  // socialMe: 'http://192.168.100.60:3000/v1',
  // socialMe : 'https://socialme-com-br.herokuapp.com/v1',
  // socialMe: 'https://dev-socialme-com-br.herokuapp.com/v1',
};

export default API;
